import { Typography } from '@mui/material';
import useDropDownItemStyles from './DropDownItem.styles';

interface Props {
	code: string;
	id: string;
	title: string;
}

const DropDownItem: React.FC<Props> = ({ code, id, title }) => {
	const classes = useDropDownItemStyles();

	return (
		<div className={classes.root} id={id}>
			<div className={classes.codeContainer} id={`${id}-code`}>
				{code}
			</div>
			<Typography
				className={classes.textContainer}
				color="#585858"
				fontFamily="Montserrat"
				fontSize={16}
				fontWeight={500}
				id={`${id}-text`}
			>
				{title}
			</Typography>
		</div>
	);
};

export default DropDownItem;
